import { render, staticRenderFns } from "./budgetInfo.vue?vue&type=template&id=5a7ecf22&"
import script from "./budgetInfo.vue?vue&type=script&lang=js&"
export * from "./budgetInfo.vue?vue&type=script&lang=js&"
import style0 from "./budgetInfo.vue?vue&type=style&index=0&id=5a7ecf22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports